import { createStore } from 'vuex';
import { toRaw } from 'vue';

import ReportDetailStore from './report-detail-store';
import { updateReport } from '@/api/providers/reports';

import store from '@/store/index';

export const EditState = {
    viewing: 1,
    editing: 2
}

export default createStore({
    state() {
        return {
            originalReport: null,
            editingReport: null,
            state: EditState.viewing,
        }
    },

    getters: {
        originalReport: state => state.originalReport,
        editingReport: state => state.editingReport,
        state: state => state.state,
        isEditing: state => state.state == EditState.editing,
    },

    mutations: {
        updateState: (state, payload) => state.state = payload,
        updateOriginalReport: (state, payload) => state.originalReport = payload,
        updateEditingReport: (state, payload) => state.editingReport = payload,
        updateEditingMessage: (state, payload) => state.editingReport.message = payload,
        updateEditingAddress: (state, payload) => state.editingReport.address = payload,
        updateEditingZipCode: (state, payload) => state.editingReport.zipCode = payload,
        updateEditingCity: (state, payload) => state.editingReport.city = payload,
        updateEditingLatitude: (state, payload) => state.editingReport.latitude = payload,
        updateEditingLongitude: (state, payload) => state.editingReport.longitude = payload,
    },

    actions: {
        async updateState({commit, state}, payload) {
            switch (payload) {
                case EditState.viewing:
                    ReportDetailStore.dispatch('updateReport', state.editingReport);

                    try {
                        await updateReport(state.editingReport);
                        commit('updateOriginalReport', { ...toRaw(ReportDetailStore.getters.report) });
                        
                        store.dispatch(
                            'notification/add',
                            {
                                description: `Wijzigingen zijn opgeslagen.`,
                                icon: {
                                component: 'feedback',
                                },
                            }
                        )
                    }
                    catch (e) {
                        store.dispatch(
                            'notification/add',
                            {
                                description: `Kon wijzigingen niet opslaan.`,
                                icon: {
                                    component: 'feedback',
                                },
                            }
                        )
                        return
                    }
                    break;
                case EditState.editing:
                    commit('updateEditingReport', { ...toRaw(ReportDetailStore.getters.report) });
                    break;
            }
            commit('updateState', payload);
        },
    
        updateEditingMessage: ({commit}, payload) =>
            commit('updateEditingMessage', payload),
    
        updateEditingAddress: ({commit}, payload) =>
            commit('updateEditingAddress', payload),

        updateEditingZipCode: ({commit}, payload) =>
            commit('updateEditingZipCode', payload),

        updateEditingCity: ({commit}, payload) =>
            commit('updateEditingCity', payload),

        updateEditingLatitude: ({commit}, payload) =>
            commit('updateEditingLatitude', payload),

        updateEditingLongitude: ({commit}, payload) =>
            commit('updateEditingLongitude', payload),

        cancelEditing({commit, state}) {
            commit('updateState', EditState.viewing);
            commit('updateEditingReport', state.originalReport);
        },
    }
});